var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { allRequestsNotStarted, someRequestIsPending, allRequestsHaveResolved, someRequestHasFailed, allRequestsHaveCompleted } from "@ane/core/lib/models/IAsyncWrapper";
import "../Spinner/index.js";
import "../MessageBar/index.js";
import "../Layout/ContentLayout/index.js";
import "../ProgressIndicator/index.js";
import "../ErrorMessages.js";
import { ContentLayout } from "../Layout/ContentLayout/ContentLayout.js";
import { ProgressIndicator } from "../ProgressIndicator/ProgressIndicator.js";
import { Spinner } from "../Spinner/Spinner.js";
import { MessageBarType } from "@fluentui/react/lib/MessageBar";
import { MessageBar } from "../MessageBar/MessageBar.js";
import { RetryButton } from "../ErrorMessages/ErrorMessages.js";
const defaultSpinnerProps = { ariaLabel: "Loading", label: "Loading" };
const defaultProgressIndicatorProps = { ariaLabel: "Loading", label: "Loading" };
const Loading = ({
  children,
  status,
  data,
  failed,
  error,
  // TODO - deprecate
  noResultsProps,
  spinnerProps = defaultSpinnerProps,
  useProgressIndicator,
  progressIndicatorProps = defaultProgressIndicatorProps,
  messageBarProps,
  useAllRequestsHaveResolved = false,
  onRetry
}) => {
  const _a = spinnerProps, { ariaLabel, label } = _a, rest = __objRest(_a, ["ariaLabel", "label"]);
  if (allRequestsNotStarted(status)) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  if (!useAllRequestsHaveResolved ? someRequestIsPending(status) : !allRequestsHaveResolved(status)) {
    return /* @__PURE__ */ jsx(ContentLayout, { children: useProgressIndicator ? /* @__PURE__ */ jsx(ProgressIndicator, __spreadValues({ barHeight: 10 }, progressIndicatorProps)) : /* @__PURE__ */ jsx(Spinner, __spreadValues({ ariaLabel, label, size: 3 }, rest)) });
  }
  if (someRequestHasFailed(status)) {
    return /* @__PURE__ */ jsx(ContentLayout, { children: /* @__PURE__ */ jsx(
      LoadingInformation,
      __spreadValues({
        heading: "There was an error",
        messageBarProps: __spreadValues({
          messageBarType: MessageBarType.error
        }, messageBarProps),
        onRetry
      }, failed)
    ) });
  }
  if (allRequestsHaveCompleted(status) && !data) {
    return /* @__PURE__ */ jsx(ContentLayout, { children: /* @__PURE__ */ jsx(
      LoadingInformation,
      __spreadValues(__spreadValues({
        heading: "No data available",
        messageBarProps: __spreadValues({
          messageBarType: MessageBarType.warning
        }, messageBarProps),
        onRetry
      }, error), noResultsProps)
    ) });
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
};
const LoadingInformation = ({ heading, message, messageBarProps, onRetry }) => {
  const _a = messageBarProps || {}, { actions } = _a, rest = __objRest(_a, ["actions"]);
  const [isExpanded, setExpanded] = React.useState(false);
  return /* @__PURE__ */ jsxs(
    MessageBar,
    __spreadProps(__spreadValues({
      ariaLabel: heading,
      isMultiline: isExpanded,
      truncated: !isExpanded,
      actions: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(RetryButton, { onRetry }),
        actions
      ] })
    }, rest), {
      onClick: () => setExpanded(!isExpanded),
      children: [
        !!heading && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("strong", { children: heading }),
          !!heading && !!message && " "
        ] }),
        !!message && /* @__PURE__ */ jsx("span", { children: message })
      ]
    })
  );
};
export {
  Loading,
  LoadingInformation
};
//# sourceMappingURL=Loading.js.map
